import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledControlsContainer = styled.div`
	position: absolute;
	left: 0;
	bottom: 80px;
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 0 80px;
`;

const StyledRightContainer = styled.div`
	position: absolute;
	top: 80px;
	right: 80px;
	display: flex;
	gap: 40px;
`;

const StyledCloseButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 10px;
	background-color: #111314;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}

	img {
		transition: filter 0.3s ease;
		pointer-events: none;
		user-select: none;
	}
`;

const StyledSearchContainer = styled.div`
	margin-top: 30px;
`;

const StyledInventoryInfoContainer = styled.div`
	height: 40px;
	padding: 0 10px;
	background-color: #111314;
	border-radius: 10px;
	display: flex;
	align-items: center;
	gap: 10px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	margin-right: -30px;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;

		span {
			opacity: 0.5;
			font-size: 16px;
			font-weight: 400;
		}
	}
`;

export {
	StyledCloseButtonContainer,
	StyledControlsContainer,
	StyledInventoryInfoContainer,
	StyledRightContainer,
	StyledSearchContainer,
};
